import React from 'react';
import { Search, Filter, X } from 'lucide-react';

const SignalementFilters = ({ filters, onFilterChange, onReset, activeFiltersCount }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Filter size={20} className="text-[#FF6B00]" />
          <h3 className="font-semibold text-gray-900">Filtres</h3>
          {activeFiltersCount > 0 && (
            <span className="px-2 py-1 bg-[#FF6B00] text-white text-xs rounded-full">
              {activeFiltersCount}
            </span>
          )}
        </div>
        {activeFiltersCount > 0 && (
          <button
            onClick={onReset}
            className="text-sm text-gray-600 hover:text-[#FF6B00] flex items-center gap-1 transition-colors"
          >
            <X size={16} />
            Réinitialiser
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-3">
        {/* Recherche */}
        <div className="relative">
          <Search size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Rechercher..."
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
            className="w-full pl-10 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
          />
        </div>

        {/* Statut */}
        <select
          value={filters.statut}
          onChange={(e) => onFilterChange('statut', e.target.value)}
          className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
        >
          <option value="">Tous les statuts</option>
          <option value="EN_ATTENTE">En attente</option>
          <option value="EN_COURS">En cours</option>
          <option value="RESOLU">Résolu</option>
          <option value="REJETE">Rejeté</option>
        </select>

        {/* Type */}
        <select
          value={filters.type}
          onChange={(e) => onFilterChange('type', e.target.value)}
          className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
        >
          <option value="">Tous les types</option>
          <option value="CONTENU_INAPPROPRIE">Contenu inapproprié</option>
          <option value="SPAM">Spam</option>
          <option value="HARCELEMENT">Harcèlement</option>
          <option value="FAUSSE_INFORMATION">Fausse information</option>
          <option value="AUTRE">Autre</option>
        </select>

        {/* Tri */}
        <select
          value={filters.ordering}
          onChange={(e) => onFilterChange('ordering', e.target.value)}
          className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B00] focus:border-transparent"
        >
          <option value="-created_at">Plus récents</option>
          <option value="created_at">Plus anciens</option>
          <option value="statut">Par statut</option>
        </select>
      </div>
    </div>
  );
};

export default SignalementFilters;
